<template>
    <el-container class="healthy page-x" direction="vertical">
        <div class="search-x">
            <div class="search-item">
                <span class="label">权益人信息</span>
                <el-input
                    class="input-box"
                    clearable
                    placeholder="权益人用户ID、姓名"
                    v-model.trim="searchBox.userInfo"
                ></el-input>
            </div>
            <div class="search-item">
                <span class="label">订单号</span>
                <el-input
                    class="input-box"
                    clearable
                    placeholder="订单号"
                    v-model.trim="searchBox.userInfo"
                ></el-input>
            </div>
            <div class="search-item">
                <span class="label">服务项目名称</span>
                <el-select v-model="searchBox.supplier" clearable>
                    <el-option
                        v-for="item in statusArr"
                        :value="item.value"
                        :key="item.value"
                        :label="item.label"
                    ></el-option>
                </el-select>
            </div>
            <div class="search-item">
                <span class="label">供应商</span>
                <el-select v-model="searchBox.supplier" clearable>
                    <el-option
                        v-for="item in statusArr"
                        :value="item.value"
                        :key="item.value"
                        :label="item.label"
                    ></el-option>
                </el-select>
            </div>

            <div class="search-item">
                <span class="label">咨询人信息</span>
                <el-input
                    class="input-box"
                    clearable
                    placeholder="咨询人用户ID、姓名"
                    v-model.trim="searchBox.userInfo"
                ></el-input>
            </div>
            <div class="search-item">
                <span class="label">服务单号</span>
                <el-input
                    class="input-box"
                    clearable
                    placeholder="服务单号"
                    v-model.trim="searchBox.userInfo"
                ></el-input>
            </div>
            <div class="search-item">
                <span class="label">咨询时间</span>
                <el-date-picker
                    v-model="timeCache.orderGeneration"
                    @change="
                        (e) =>
                            toChangeTime(
                                e,
                                'orderGenerationStart',
                                'orderGenerationEnd'
                            )
                    "
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="{
                        disabledDate(time) {
                            return time.getTime() > Date.now();
                        },
                    }"
                >
                </el-date-picker>
            </div>
            <el-button v-auth="'sa_order_page'" type="primary" @click="toSearch"
                >查询</el-button
            >
            <el-button
                v-auth="'sa_order_page'"
                type="primary"
                @click="() => ($root.showPage = false)"
                >重置</el-button
            >
            <el-button
                v-auth="'sa_order_export'"
                type="warning"
                @click="toExport"
                >导出数据</el-button
            >
        </div>
        <div class="cont-x">
            <div class="table-x" ref="tableBox">
                <el-table
                    v-loading="loading"
                    :data="tableData"
                    border
                    class="mb20"
                >
                    <el-table-column
                        type="index"
                        align="center"
                        label="序号"
                        width="60"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="orderNo"
                        align="center"
                        label="订单号"
                        width="200"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="服务单号"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="服务项目名称"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="咨询人姓名"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="手机号"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="权益用户ID"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="权益人姓名"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="与权益人关系"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="咨询时间"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="供应商"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="操作"
                    >
                        <template slot-scope="scope">
                            <el-button
                                size="middle"
                                class="mb10"
                                type="text"
                                @click="showDetail(scope.row)"
                                >查看</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="pagenation-x">
            <div class="pagination mb20">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="searchBox.pageNo"
                    :page-size.sync="searchBox.pageSize"
                    layout="total,  prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <drag-dialog
            title="电话医生服务详情"
            v-model="dialogVisible"
        >
            <div class="dialog-list">
                <div class="title">基本信息</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">姓名：</div>
                    <div class="dialog-list-text">{{dialogData.name}}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">手机号：</div>
                    <div class="dialog-list-text">{{dialogData.name}}</div>
                </div>
                <div class="title">咨询记录</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">咨询时间：</div>
                    <div class="dialog-list-text">{{dialogData.name}}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">咨询分类：</div>
                    <div class="dialog-list-text">{{dialogData.name}}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">分科：</div>
                    <div class="dialog-list-text">{{dialogData.name}}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">主诉：</div>
                    <div class="dialog-list-text">{{dialogData.name}}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">预评估：</div>
                    <div class="dialog-list-text">{{dialogData.name}}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">总结：</div>
                    <div class="dialog-list-text">{{dialogData.name}}</div>
                </div>
                <div class="title">服务评价</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">用户评价：</div>
                    <div class="dialog-list-text">{{dialogData.name}}</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">返回</el-button>
            </span>
        </drag-dialog>
    </el-container>
</template>

<script>
import dragDialog from "@/components/health/dragDialog.vue";
import { dateFormat } from "@/assets/js/until.js";
export default {
    name: "healthy",
    components: { dragDialog },
    data() {
        return {
            // table表格
            loading: false,
            tableData: [], // table数据
            total: 0,
            // 查询条件
            timeCache: {}, // 时间缓存
            statusArr: [],
            searchBox: {
                pageSize: 10,
                pageNo: 1,
            }, // 搜索条件
            // 弹窗
            dialogVisible: false, // 弹窗visible
            dialogData: {}, // 弹窗中的数据
        };
    },
    created() {
        // 面包导航
        this.$root.breadList = [
            { name: "服务订单", link: "" },
            { name: "电话医生订单", link: "" },
        ];
    },
    mounted() {
        this.getData();
    },
    methods: {
        /**
         * 显示弹窗
         */
        showDetail(data) {
            this.dialogVisible = true;
            this.dialogData = data;
        },
        /**
         * 搜索按钮
         */
        toSearch() {
            this.searchBox.pageNo = 1;
            this.getData();
        },
        /**
         * 导出数据
         */
        toExport() {
            console.log("导出");
        },
        /**
         * 获取数据
         */
        getData() {
            this.tableData = [{}];
            console.log("获取数据");
        },
        /**
         * 换页
         */
        handleCurrentChange(val) {
            this.searchBox.pageNo = val;
            this.getData();
        },
        /**
         * 时间回调函数
         */
        toChangeTime(val, startName, endName) {
            console.log(val);
            if (val && val.length) {
                this.searchBox[startName] = dateFormat(val[0]);
                this.searchBox[endName] = dateFormat(val[1]);
            } else {
                this.searchBox[startName] = "";
                this.searchBox[endName] = "";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";
.dialog-list {
    .title {
        height: 30px;
        line-height: 30px;
        margin-bottom: 20px;
        font-weight: bold;
        padding-left: 20px;
        margin-top: 18px;
        position: relative;
        &::before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 8px;
            background-color: $theme;
        }
    }
    .dialog-list-box {
        padding-bottom: 10px;
        display: flex;
        .dialog-list-title {
            padding-left: 20px;
            width: 80px;
            white-space: nowrap;
            text-align: right;
        }
        .dialog-list-text {
            flex: 1;
        }
    }
}
</style>